<template>

<ModalFrame class="successPopupFrame" @click="onClose">
  <FrameWindow
    class="successPopup"
    role="dialog"
    aria-modal="true"
    aria-labelledby="success-popup-title"
    aria-describedby="success-popup-description">
    <CloseButton class="successPopup__close" aria-label="Close" @click="onClose" />

    <div class="successPopup__content">
      <h2 id="success-popup-title" class="successPopup__title">Thank you!</h2>
      <p id="success-popup-description" class="successPopup__description">
        We’ve received your request and will get back to you shortly.
      </p>
    </div>
  </FrameWindow>
</ModalFrame>

</template>

<script setup>
import { store } from '@/store';
import CloseButton from '@/Components/EnNew/UI/CloseButton.vue';
import ModalFrame from '@/Components/EnNew/Modals/ModalFrame.vue';
import FrameWindow from '@/Components/EnNew/Modals/FrameWindow.vue';

defineOptions({ name: 'SuccessPopup' });

const onClose = () => store.successPopupStore.close();
</script>

<style lang="sass">

@use '@vars' as *

.successPopupFrame
  z-index: 700

.successPopup
  width: min(420px, calc(100% - 30px))
  padding: 40px 36px 34px

.successPopup__close
  position: absolute
  top: 12px
  right: 12px

.successPopup__content
  display: flex
  flex-direction: column
  gap: 12px

  text-align: center

.successPopup__title
  margin: 0

  color: $text-1
  font-size: 28px
  font-weight: 600
  line-height: 110%

.successPopup__description
  margin: 0

  color: $text-4
  font-size: 16px
  font-weight: 400
  line-height: 140%

@media #{$mobile}
  .successPopup
    padding: 36px 24px 28px

  .successPopup__title
    font-size: 24px

  .successPopup__description
    font-size: 14px

</style>
